<strong>Test ok</strong>

<button (click)="openModal()">Imprimir</button>


